import { useEffect, useRef } from 'react';

export const useMouseListener = () => {
  // Resizer
  const leftPaneRef = useRef();
  const resizerRef = useRef();
  const rightPaneRef = useRef();
  let x = 0;
  let rightWidth = 0;

  // Handle the moving mouse - https://htmldom.dev/create-resizable-split-views/
  const mouseMoveHandler = (e) => {
    const mouseX = e.clientX;
    const dx = mouseX - x;
    const overallWidth = resizerRef.current.parentNode.getBoundingClientRect().width;

    const newRightWidth = ((rightWidth - dx) * 100) / overallWidth;
    // The flexBasis is equal to the width
    // We only need to change the width of the left pane
    rightPaneRef.current.style.flexBasis = `${newRightWidth}%`;

    // Disable accidentally selecting text
    leftPaneRef.current.style.userSelect = 'none';
    leftPaneRef.current.style.pointerEvents = 'none';
    rightPaneRef.current.style.userSelect = 'none';
    rightPaneRef.current.style.pointerEvents = 'none';
  };
  const mouseUpHandler = () => {
    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);

    // Remove disabling of selecting text
    leftPaneRef.current.style.removeProperty('user-select');
    leftPaneRef.current.style.removeProperty('pointer-events');
    rightPaneRef.current.style.removeProperty('user-select');
    rightPaneRef.current.style.removeProperty('pointer-events');
  };
  const mouseDownHandler = (e) => {
    x = e.clientX;
    rightWidth = rightPaneRef.current.getBoundingClientRect().width;
    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  };

  // On component load, add mousedown listener
  useEffect(() => {
    const eventRef = resizerRef.current;
    eventRef.addEventListener('mousedown', mouseDownHandler);
    return () => {
      eventRef.removeEventListener('mousedown', mouseDownHandler);
    };
  });

  return [leftPaneRef, resizerRef, rightPaneRef];
};
